<template>
  <div>
    <b-modal
      :id="modalId"
      size="lg"
      :title="`Cancelar ${documentLabel}`"
      ok-title="Salvar"
      centered
      @hidden="clear"
    >
      <template #modal-footer>
        <div
          class="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-between"
        >
          <div>
            <b-button
              :disabled="motivo.length <= 15"
              variant="info"
              size="sm"
              @click="cancelNota"
              >Prosseguir</b-button
            >
          </div>

          <div v-if="spinLoading">
            <b-spinner
              style="width: 2rem; height: 2rem"
              variant="primary"
            ></b-spinner>
          </div>
        </div>
      </template>
      <b-row class="d-flex">
        <b-form-group
          id="input-group-1"
          label="Motivo do cancelamento!"
          label-for="input-1"
          class="col-sm-12 col-md-12 col-lg-12 col-xl-12"
        >
          <b-form-input
            placeholder="Min: 15 caracteres"
            size="md"
            v-model="motivo"
          ></b-form-input>
        </b-form-group>
      </b-row>
      <div class="cancellationNotice">
        <ul>
          <li>{{ cancellationNotice }}</li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
import serviceNotaFiscal from "../../services/serviceNotaFiscal";
import { HandleErrors } from "../../utils/handleErrors";

export default {
  props: {
    idNota: {
      type: Object,
    },
    modalId: {
      type: String,
      default: "modalCancelNota",
    },
    documentType: {
      type: String,
      default: "nfe",
      validator: (value) => ["nfe", "nfce"].includes(value),
    },
  },
  data() {
    return {
      motivo: "",
      spinLoading: false,
      alterValueEvent: false,
    };
  },
  computed: {
    isNfce() {
      return this.documentType === "nfce";
    },
    documentLabel() {
      return this.isNfce ? "NFC-e" : "NF-e";
    },
    cancellationNotice() {
      return this.isNfce
        ? "O prazo máximo para cancelamento de uma NFC-e é de até 30 MINUTOS após a concessão da autorização de uso."
        : "O prazo máximo para cancelamento de uma NF-e é de até 24 HORAS após a concessão da autorização de uso.";
    },
  },
  methods: {
    async cancelNota() {
      try {
        const dataCancelamento = {
          uuid: this.idNota.uuidNotaWebMania,
          motivo: this.motivo,
        };

        this.spinLoading = true;
        await serviceNotaFiscal.cancelNota(
          dataCancelamento,
          this.idNota.idNota
        );

        this.$emit("getNotaAfterCanceled", !this.alterValueEvent);
        this.$toast.open({
          message: `${this.documentLabel} cancelada!`,
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        const typeError = HandleErrors(message);

        if (typeError.message && typeError.message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: typeError.message.split(":")[1],
            type: "info",
          });
        else
          return this.$toast.open({
            message: typeError.message,
            type: "error",
          });
      } finally {
        this.spinLoading = false;
        this.$bvModal.hide(this.modalId);
      }
    },
    clear() {
      this.motivo = "";
    },
  },
};
</script>

<style scoped>
.cancellationNotice {
  color: red;
  font-size: 11px;
  margin-left: 50px;
}

p {
  margin: 0;
}
</style>
